import React from 'react';
import ReactDOM from 'react-dom';
import '../Modal/modal.css';
import ModalBody from './ModalBody';
import AfterCloseFeedbackBody from './AfterCloseFeedbackBody';

const AfterCloseFeedback = ({ isShowing, val, hide }) => {
  console.log(val);

  return isShowing ? (
    <React.Fragment>
      <div className="modal-overlay" />
      <div className="modal-wrapper" aria-modal aria-hidden role="dialog">
        <AfterCloseFeedbackBody open={isShowing} handleClose={hide} data={val} ></AfterCloseFeedbackBody>
      </div>
    </React.Fragment>
  ) : null;
}

export default AfterCloseFeedback;